import { Image, ImageProps } from 'react-native';
import Animated from 'react-native-reanimated';
import type { AnimatedProps } from 'react-native-reanimated';

import React from 'react';
import logo from '../../../assets/images/brand/logo.png';
import logoLight from '../../../assets/images/brand/logo-light.png';
import { useIsLightColorScheme } from '../hooks/useIsLightColorScheme';

interface LogoProps extends Partial<ImageProps> {
  animated?: boolean;
  animatedProps?: Partial<AnimatedProps<ImageProps>>;
}
const Logo = ({ animated, animatedProps, ...props }: LogoProps) => {
  const isLightTheme = useIsLightColorScheme();
  if (animated) {
    return (
      <>
        <Animated.Image {...animatedProps} source={isLightTheme ? logo : logoLight} />
      </>
    );
  }
  return (
    <>
      <Image {...props} source={isLightTheme ? logo : logoLight} />
    </>
  );
};

export default Logo;
